import { createORPCSetup } from "@planvera/app-commons/orpc";
import type { AppRouterClient } from "./api-types";

const { client, orpc, queryClient, invalidateCsrfToken } =
	createORPCSetup<AppRouterClient>({
		apiUrl: import.meta.env.VITE_API_URL,
		enableOffline: false,
		enableSentry: true,
	});

export { client, invalidateCsrfToken, orpc, queryClient };
